import React from "react";

function CardWithoutQR() {
  return <div>CardWithoutQR</div>;
}

export default CardWithoutQR;
